export default __webpack_public_path__ + "static/media/topnote-logo.960b7891.jpg";